import React from 'react';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomerReviewCard from 'components/consumer/customer-reviews-list/CustomerReviewCard';
import useScreen from 'hooks/useScreen';
import { useInfiniteHits } from 'react-instantsearch';

const ResultsHeader = ({ variant = 'desktop', children }) => (
  <div
    className={classNames('mx-0 my-2.5 text-base font-bold', {
      'hidden lg:block': variant === 'advanced-search',
      'text-gray': variant !== 'mobile',
      'text-brand block mt-[15px] mb-[7px]': variant === 'mobile',
    })}
  >
    {children}
  </div>
);

const CustomerReviews = ({ variant = 'advanced-search', forComponent }) => {
  const { items, showMore, isLastPage } = useInfiniteHits();
  const { windowWidth } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? '2800px' : '2200px';

  const reviewsList = items.map((hit, index) => (
    <CustomerReviewCard
      key={hit.review_id || hit.objectID || index}
      productReview={hit}
      type="search"
      variant="advanced-search"
    />
  ));

  if (!items || items.length === 0) {
    return (
      <div className="w-full flex items-center justify-center min-h-[20vh]">
        <div className="text-center">
          <div
            className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-2"
            role="status"
            aria-label="Loading"
          />
        </div>
      </div>
    );
  }
  return (
    <>
      <ResultsHeader variant={variant}>
        {forComponent === 'mobile' ? 'Results' : 'Reviews'}
      </ResultsHeader>

      <InfiniteScroll
        dataLength={reviewsList.length}
        next={showMore}
        hasMore={!isLastPage}
        scrollThreshold={infiniteScrollThreshold}
        loader={<h4>Loading...</h4>}
      >
        <div data-xc="reviews-list-container">{reviewsList}</div>
      </InfiniteScroll>
    </>
  );
};

export default CustomerReviews;
